import { render } from "./IconEdit.vue?vue&type=template&id=8d935c94"
const script = {}

import exportComponent from "/home/roland/vscode/diablo/newsroom/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"IconEdit.vue"]])

export default __exports__